import React, { useEffect, useState, useRef } from 'react';
import { collection, doc, getDoc, setDoc, addDoc, query, getDocs, where } from 'firebase/firestore';
import { db } from '../firebase/firebase';
import { useParams } from 'react-router-dom';
import styled from "styled-components"
import AdminNav from './AdminNav';

export default function RegisterByggevarehus() {
  const { id } = useParams(); // Get the id from the url, undefined if not present
  const [name, setName] = useState('');
  const [address, setAddress] = useState('');
  const [lat, setLat] = useState('');
  const [lng, setLng] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [employees, setEmployees] = useState([{ name: '', email: '' }]);
  const addressInputRef = useRef();

  useEffect(() => {
    if (id) { // If id is provided, fetch data for the byggevarehus to edit
      const fetchByggevarehus = async () => {
        const byggevarehusDoc = await getDoc(doc(db, 'byggevarehus', id));
        const byggevarehusData = byggevarehusDoc.data();
        setName(byggevarehusData.name);
        setAddress(byggevarehusData.address);
        setLat(byggevarehusData.lat);
        setLng(byggevarehusData.lng);
        setPhoneNumber(byggevarehusData.phoneNumber);
        setEmployees(byggevarehusData.employees || [{ name: '', email: '' }]);
      };
      fetchByggevarehus();
    }

    const initializeAutocomplete = () => {
      if (!addressInputRef.current) {
        return;
      }

      const autocomplete = new window.google.maps.places.Autocomplete(addressInputRef.current);

      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();
        setName(place.name);
        setAddress(place.formatted_address);

        const location = place.geometry.location;
        setLat(location.lat());
        setLng(location.lng());
      });
    };

    initializeAutocomplete();
  }, [id]); // Added id to the dependency array, so the hook runs again when id changes

  const handleAddEmployee = () => {
    setEmployees(prevEmployees => [...prevEmployees, { name: '', email: '' }]);
  };

  const handleChangeEmployee = (index, event) => {
    const values = [...employees];
    values[index][event.target.name] = event.target.value;
    setEmployees(values);
  };

  // Updated the function to handle both create and update operations
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const confirmation = window.confirm('Are you sure you want to save this byggevarehus?');
    if (!confirmation) {
      return;
    }
  
    // Check if a byggevarehus with the same name already exists (not including the current byggevarehus)
    const existingByggevarehusQuery = query(collection(db, 'byggevarehus'), where('name', '==', name));
    const existingByggevarehusSnapshot = await getDocs(existingByggevarehusQuery);
    if (!existingByggevarehusSnapshot.empty && (!id || existingByggevarehusSnapshot.docs[0].id !== id)) {
      alert('A byggevarehus with this name is already registered');
      return;
    }
  
    const newByggevarehus = {
      name,
      address,
      lat,
      lng,
      phoneNumber,
      employees,
    };
  
    try {
      if (id) {
        // Update an existing document
        await setDoc(doc(db, 'byggevarehus', id), newByggevarehus);
        alert('Byggevarehus updated successfully');
      } else {
        // Create a new document with an auto-generated ID
        const docRef = await addDoc(collection(db, 'byggevarehus'), newByggevarehus);
        // Update the document to include the auto-generated ID
        await setDoc(doc(db, 'byggevarehus', docRef.id), { ...newByggevarehus, id: docRef.id });
        alert('Byggevarehus registered successfully');
      }
    } catch (error) {
      console.error("Error adding/updating document: ", error);
    }
  };

  return (
    <StyledDiv>
    <AdminNav/>
      <h2>{id ? 'Edit' : 'Register'} Byggevarehus</h2>
      <form onSubmit={handleSubmit}>
        <label>
          Search: 
          <input type="text" ref={addressInputRef} />
        </label>
        <label>
          Name: 
          <input type="text" value={name} onChange={e => setName(e.target.value)} />
        </label>
        <label>
          Address: 
          <input type="text" value={address} onChange={e => setAddress(e.target.value)} />
        </label>
        <label>
          Phone Number: 
          <input type="text" value={phoneNumber} onChange={e => setPhoneNumber(e.target.value)} />
        </label>
        {employees.map((employee, index) => (
          <div key={index}>
            <label>
              Employee Name: 
              <input type="text" name="name" value={employee.name} onChange={e => handleChangeEmployee(index, e)} />
            </label>
            <label>
              Employee Email: 
              <input type="email" name="email" value={employee.email} onChange={e => handleChangeEmployee(index, e)} />
            </label>
          </div>
        ))}
        <button type="button" onClick={handleAddEmployee}>Add Employee</button>
        <button type="submit">{id ? 'Update' : 'Register'}</button>
      </form>
    </StyledDiv>
  );
}



const StyledDiv = styled.div`
  margin: 0 auto;
  padding: 1rem;
  max-width: 500px;
  border-radius: 8px;
  box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.1);

  h2 {
    text-align: center;
    margin-bottom: 1.5rem;
  }

  form {
    display: flex;
    flex-direction: column;
  }

  label {
    display: flex;
    flex-direction: column;
    margin-bottom: 1rem;
  }

  input[type="text"], input[type="email"] {
    padding: 0.5rem;
    border-radius: 4px;
    border: 1px solid #ccc;
  }

  button {
    padding: 0.5rem 1rem;
    border-radius: 4px;
    border: none;
    background-color: #4caf50;
    color: white;
    cursor: pointer;
    margin-top: 1rem;
    align-self: flex-end;
  }

  button[type="button"] {
    background-color: #f44336;
    margin-right: 1rem;
  }
`;